import React from 'react';
import { buildVersion } from '../../utils/buildInfo';
import styles from './BuildVersionBadge.module.css';

const BuildVersionBadge: React.FC = () => (
    <div className={styles.badge} title={`Build ${buildVersion}`}>v{buildVersion}</div>
);

export default BuildVersionBadge;
